<template>
  <div class="vat-preview-loading text-center py-4">
    <b-spinner variant="primary" small />
    <p class="mt-2 mb-0 text-muted loading-text">
      Đang tính toán...
    </p>
  </div>
</template>

<script>
export default {
  name: 'VatPreviewLoading',
};
</script>

<style lang="scss" scoped>
.vat-preview-loading {
  .loading-text {
    font-size: 0.82rem;
  }
}
</style>
